const verticalTimeline = () => {
    const timelineContainers = document.querySelectorAll('[data-timeline]')
    if (!timelineContainers.length) return

    timelineContainers.forEach((timelineContainer) => {
        initializeTimeline(timelineContainer)
    })
}

const scrollToItem = (target) => {
    target.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
    })
}

const initializeTimeline = (timelineContainer) => {
    const timelineItems = timelineContainer.querySelectorAll('[data-timeline-item]')
    const dotsContainer = timelineContainer.querySelector('.dots')
    const sidebarDots = dotsContainer.querySelectorAll('[data-timeline-year]')
    

    if (!timelineItems.length || !sidebarDots.length) return

    const prevButton = timelineContainer.querySelector('[data-timeline-prev-button]')
    const nextButton = timelineContainer.querySelector('[data-timeline-next-button]')

    const handleButtonClick = (button) => {
        const year = button.getAttribute('data-timeline-year')
        const targetItem = timelineContainer.querySelector(`[data-timeline-item="${year}"]`)
        
        if (targetItem) {
            scrollToItem(targetItem)
        }
    }

    if (prevButton) {
        prevButton.addEventListener('click', () => handleButtonClick(prevButton))
    }

    if (nextButton) {
        nextButton.addEventListener('click', () => handleButtonClick(nextButton))
    }
  

    sidebarDots.forEach(button => {
        button.addEventListener('click', () => {
            const year = button.getAttribute('data-timeline-year')
            const targetItem = timelineContainer.querySelector(`[data-timeline-item="${year}"]`)
            
            if (targetItem) {
                scrollToItem(targetItem)
            }
        })
    })

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const year = entry.target.getAttribute('data-timeline-item')

                handleActiveItemChange(year)
                
                sidebarDots.forEach(button => {
                    button.classList.remove('active')
                })
                
                const activeButton = dotsContainer.querySelector(`[data-timeline-year="${year}"]`)
                if (activeButton) {
                    activeButton.classList.add('active')
                }

                dotsContainer.scrollTo({
                    top: activeButton.offsetTop - 100,
                    behavior: 'smooth'
                })
            }
        })
    }, {
        threshold: 1,
        rootMargin: '-20% 0px -20% 0px'
    })

    timelineItems.forEach(item => {
        observer.observe(item)
    })

    // When the active item changes, update the previous and next buttons
    const handleActiveItemChange = (year) => {
        const items = dotsContainer.querySelectorAll(`[data-timeline-year]`)
        const activeIndex = Array.from(items).findIndex(item => item.getAttribute('data-timeline-year') === year)

        if (prevButton) {
            prevButton.disabled = activeIndex === 0
            const potentialPrevYear = items[activeIndex - 1]

            if (potentialPrevYear) {
                prevButton.setAttribute('data-timeline-year', potentialPrevYear.getAttribute('data-timeline-year'))
            }
        }

        if (nextButton) {
            nextButton.disabled = activeIndex === items.length - 1

            const potentialNextYear = items[activeIndex + 1]
            if (potentialNextYear) {
                nextButton.setAttribute('data-timeline-year', potentialNextYear.getAttribute('data-timeline-year'))
            }
        }
    }
}

export default verticalTimeline
